import api from './api';

export const askAI = (message, history = []) =>
  api.post('/ai/chat', { message, history });

// Last 10 saved exchanges, oldest first - hydrates the Chat tab so a
// browser refresh doesn't lose the conversation. employeeId is CEO-only
// (viewing someone else's history); omit for the caller's own.
export const getChatHistory = (employeeId) =>
  api.get('/ai/chat/history', { params: employeeId ? { employee_id: employeeId } : {} });

export const deleteChatHistory = () => api.delete('/ai/chat/history');

export const reviewDocument = (file, { checklistId, questions } = {}) => {
  const formData = new FormData();
  formData.append('file', file);
  if (checklistId) formData.append('checklist_id', checklistId);
  if (questions) formData.append('questions', questions);
  // No explicit Content-Type - see api.js's 2026-09-13 comment on why
  // setting it here breaks the multipart boundary axios/the browser add
  // automatically for a FormData body.
  return api.post('/ai/documents/review', formData);
};

// Chunked background review of the WHOLE document (no truncation) - for
// files too large for a single request. Returns a job immediately; poll
// getReviewJob(id) for progress until status is 'done' or 'failed'.
export const reviewDocumentFull = (file, { checklistId, questions } = {}) => {
  const formData = new FormData();
  formData.append('file', file);
  if (checklistId) formData.append('checklist_id', checklistId);
  if (questions) formData.append('questions', questions);
  return api.post('/ai/documents/review-full', formData);
};

export const getReviewJob = (jobId) => api.get(`/ai/documents/review-jobs/${jobId}`);

// Last 10 reviewed documents (both single and full/chunked), newest
// first - no full result text, just enough to list and pick from; reopen
// one with getReviewJob(id). employeeId is CEO-only (viewing someone
// else's history); omit for the caller's own.
export const listReviewHistory = (employeeId) =>
  api.get('/ai/documents/reviews', { params: employeeId ? { employee_id: employeeId } : {} });

export const listDocumentTypes = () => api.get('/ai/checklists/document-types');

export const listChecklists = (documentType) =>
  api.get('/ai/checklists/', { params: documentType ? { document_type: documentType } : {} });

export const createChecklist = (documentType, name, questions) =>
  api.post('/ai/checklists/', { document_type: documentType, name, questions });

export const updateChecklist = (checklistId, payload) =>
  api.put(`/ai/checklists/${checklistId}`, payload);

export const deleteChecklist = (checklistId) => api.delete(`/ai/checklists/${checklistId}`);
